import { type FontFormat, MAX_FONT_FAMILY_NAME_LENGTH } from '@repo/api-contracts';
import type { ReactElement } from 'react';
import type { RenameController } from '@/shared/lib';
import { Button, cn, InlineRenameForm, tableStyles } from '@/shared/ui';

interface FontRowFont {
  readonly id: string;
  readonly familyName: string;
  readonly format: FontFormat;
}

interface FontRowProps {
  readonly font: FontRowFont;
  readonly rename: RenameController;
  readonly onRenameStart: (font: FontRowFont) => void;
  readonly onDelete: (font: FontRowFont) => void;
}

/** 폰트 표의 한 행 — 이름(인라인 수정)·형식·삭제. 형식·파일은 바꿀 수 없다. */
export const FontRow = ({ font, rename, onRenameStart, onDelete }: FontRowProps): ReactElement => {
  const isRenaming = rename.target?.id === font.id;

  return (
    <tr className={tableStyles.row}>
      <td className={cn(tableStyles.td, 'font-medium')}>
        {isRenaming && rename.target ? (
          <InlineRenameForm
            ariaLabel={`${font.familyName} 새 이름`}
            name={rename.target.name}
            maxLength={MAX_FONT_FAMILY_NAME_LENGTH}
            isPending={rename.target.isPending}
            onNameChange={rename.onChange}
            onSubmit={rename.onSubmit}
            onCancel={rename.onCancel}
          />
        ) : (
          font.familyName
        )}
      </td>
      <td className={cn(tableStyles.td, 'text-muted-foreground')}>{font.format.toUpperCase()}</td>
      <td className={tableStyles.td}>
        <span className="flex items-center gap-1">
          {isRenaming ? null : (
            <Button variant="ghost" size="sm" onClick={() => onRenameStart(font)}>
              수정
            </Button>
          )}
          <Button
            variant="ghost"
            size="sm"
            className="text-destructive"
            aria-label={`${font.familyName} 삭제`}
            onClick={() => onDelete(font)}
          >
            삭제
          </Button>
        </span>
      </td>
    </tr>
  );
};
